export const isEmpty = function(item) {
  if (typeof item === "undefined") {
    return true;
  }
  if (item === null) {
    return true;
  }
  if (typeof item === "object") {
    const provided = Object.keys(item);
    if (!provided.length) {
      return true;
    }
  }
  return false;
};

export default isEmpty;
